import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("cmc_token", res.data.token);
      localStorage.setItem("cmc_email", res.data.email);
      navigate("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="max-w-[440px] mx-auto px-6 py-20 md:py-28">
      <div className="overline">Admin</div>
      <h1 className="font-serif text-4xl mt-3">Sign in</h1>
      <p className="text-sm text-brand-muted mt-3">Manage products and view orders.</p>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <label className="overline block mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email"
            required
            className="w-full border border-brand-line bg-brand-bg px-4 py-3 text-sm focus:outline-none focus:border-brand-ink"
          />
        </div>
        <div>
          <label className="overline block mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
            required
            className="w-full border border-brand-line bg-brand-bg px-4 py-3 text-sm focus:outline-none focus:border-brand-ink"
          />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-primary w-full">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
